<template>
  <slot v-if="showSlot"></slot>
</template>
<script>
export default {
  props: {
    timeout: {
      default: 10000
    }
  },
  data() {
    return {
      showSlot: true
    };
  },
  methods: {},
  mounted() {
    setTimeout(() => {
      this.showSlot = false;
    }, this.timeout);
  }
};
</script>
